var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.show ? _c('div', {
    staticClass: "popSlippage popPrompt",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": _vm.onClose
    }
  }), _c('transition', {
    attrs: {
      "appear": "",
      "name": "popPromptCenter"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "popPrompt-main center"
  }, [_c('div', {
    staticClass: "btn-close btn",
    on: {
      "click": _vm.onClose
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _c('div', {
    staticClass: "popPrompt__title"
  }, [_vm._v(_vm._s(_vm.$lang("Slippage")))]), _c('div', {
    staticClass: "popPrompt-con"
  }, [_c('div', {
    staticClass: "popSlippage__sub"
  }, [_vm._v("Set the maximum slippage limit, which must not exceed 50%.")]), _c('div', {
    staticClass: "popSlippage-input hover"
  }, [_c('div', {
    staticClass: "popSlippage-input__tag"
  }, [_vm._v("%")]), _c('div', {
    staticClass: "popSlippage-input-main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.slippageNum,
      expression: "slippageNum"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.slippageNum
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.slippageNum = $event.target.value;
      }, _vm.onInput]
    }
  })])]), _c('div', {
    staticClass: "popSlippage-switch"
  }, _vm._l([0.1, 0.5, 1, 2, 5, 10], function (item, index) {
    return _c('div', {
      staticClass: "popSlippage-switch__item hover",
      class: _vm.selectSwitch == item && 'active',
      on: {
        "click": function ($event) {
          return _vm.onSwitch(item);
        }
      }
    }, [_vm._v(_vm._s(item) + "%")]);
  }), 0), _c('div', {
    staticClass: "btn-apply btn",
    on: {
      "click": _vm.onApply
    }
  }, [_vm._v(_vm._s(_vm.$lang("Apply")))])])])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };